export default "__VITE_ASSET__DjSNEynU__"